<template lang="">
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="3">
				<!-- branch -->
				<sf-select-group
					:inputValue="searchParams.branch"
					:label="getMessage_('SWCC000768')"
					:options="this.branches"
					:onChange="value => change('branch', value)"
				/>
			</el-col>
			<el-col :span="3">
				<!-- Language -->
				<sf-select-group
					:inputValue="searchParams.lang"
					:label="getMessage_('SWCC000397')"
					:options="this.langs"
					:onChange="value => change('lang', value)"
				/>
			</el-col>
			<el-col :span="3">
				<!-- service -->
				<sf-select-group
					:inputValue="searchParams.service"
					:label="getMessage_('SWCC000250')"
					:options="this.services"
					:onChange="value => change('service', value)"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000770')"
					:inputValue="searchParams.library"
					:onChange="value => change('library', value)"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000330')" :inputValue="searchParams.ver" :onChange="value => change('ver', value)" />
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="() => searchList()">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/LibraryDependency/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...serviceComputed,
		...rootComputed
	},
	methods: {
		...serviceMethods,
		change(key, value) {
			this.setSearchParam_({
				key,
				value
			});
			if (key === 'branch' || key === 'service' || key === 'lang') {
				this.getCommonCodes_();
				this.searchList();
			}
		},
		async searchList(currentPage = 1, pageUnit = this.pagingInfo.pageUnit) {
			this.$sf_toggleLoading(true);
			// let header = await this.getErrorLogList_({ searchParams, currentPage, pageUnit });
			await this.getDependencies_({ currentPage, pageUnit })
				.catch(e => {
					this.$sf_toast({
						title: 'error',
						type: 'error',
						position: 'bottom-right',
						message: this.getMessage_(e.header.messageCd)
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async getDefaultSelect() {
			await this.getCommonCodes_();
			// await this.setSearchParam_({ key: 'line', value: this.lines.length > 0 ? this.lines[0].value : '' });
			//await this.setSearchParam_({ key: 'service', value: this.services.length > 0 ? this.services[0].value : '' });
			//await this.setSearchParam_({ key: 'lang', value: this.langs.length > 0 ? this.langs[0].value : '' });
			await this.getPlants_().then(header => {
				// 아직 sf_setToastOption 안됨
				// 어디에만 띄울지도 확인 필요
				// this.$sf_toast({
				// 	...this.$sf_setToastOption(header),
				// 	message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message,
				// });
				// this.$sf_toast({
				// 	icon: header.code === 0 ? 'ok' : 'error',
				// 	title: header.message,
				// 	position: 'bottom-right',
				// 	message: header.message,
				// });
			});
			// .catch(e => {
			// 	this.$sf_toast({ type: 'error', message: e.message });
			// });
			await this.defaultSelect({ optionNm: 'plants', valueNm: 'plant' });
			await this.getLogTypes_({ plantCd: this.plant, commCdType: 'MSG_TYPE' }).then(header => {
				// this.$sf_toast({
				// 	icon: header.code === 0 ? 'ok' : 'error',
				// 	title: header.message,
				// 	position: 'bottom-right',
				// 	message: header.message,
				// });
			});
			// .catch(e => {
			// 	this.$sf_toast({ type: 'error', message: e.message });
			// });
			await this.changeValue({ name: 'logType', value: this.logTypes[0].value });
		},
		async pageLoad() {
			await this.getDefaultSelect();
			await this.searchList();
		}
	},
	created() {
		this.pageLoad();
	},
	watch: {
		langCd() {
			this.getLogTypes_({ plantCd: this.plant, commCdType: 'MSG_TYPE' }).then(header => {
				// this.$sf_toast({
				// 	icon: header.code === 0 ? 'ok' : 'error',
				// 	title: header.message,
				// 	position: 'bottom-right',
				// 	message: header.message,
				// });
			});
		}
	}
};
</script>
<style>
.flexStyle {
	display: flex;
}
</style>
